export default __webpack_public_path__ + "static/media/c.cfdb5e91.png";